export default __webpack_public_path__ + "static/media/dog.f25b97b3.svg";